import type { SpecialModule } from '../specials/types';
import type { StepContext } from '../systems/types';

// Set a bar ahead, so that every system knows the blank's first tick before it comes.
export const blackout: SpecialModule = ({ state, tempo }, enemy, effect) => {
  if (
    effect.kind !== 'blackout' ||
    state.blackout !== undefined ||
    !state.events.some((event) => event.type === 'bar') ||
    state.set.bar % effect.everyBars !== effect.everyBars - effect.bars - 1
  ) {
    return;
  }
  const startTick = state.tick + tempo.ticksPerBar;
  state.blackout = {
    byId: enemy.id,
    startTick,
    endTick: startTick + effect.bars * tempo.ticksPerBar,
  };
};

// Before the weapons, so that they play on the very tick the blank ends.
export function endBlackout({ state }: StepContext): void {
  const { blackout: blank } = state;
  if (
    blank !== undefined &&
    (state.tick >= blank.endTick ||
      !state.enemies.some((enemy) => enemy.id === blank.byId && enemy.hp > 0))
  ) {
    delete state.blackout;
  }
}
